import { dashboardBackgroundScriptsLayout } from '@atlassian/jira-background-scripts-layout/src/index.tsx';
import { DASHBOARD } from '@atlassian/jira-capabilities/src/constants.tsx';
import { NORMAL_EARLY_ASSET_STRATEGY } from '@atlassian/jira-common-constants/src/ssr-early-assets.tsx';
import { globalLayout } from '@atlassian/jira-global-layout/src/index.tsx';
import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { composeLayouts } from '@atlassian/jira-route-layout/src/GlobalComponent.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { dashboardViewRoute } from '@atlassian/jira-router-routes-dashboard-routes/src/dashboardViewRoute.tsx';
import { dashboardViewEntryPoint } from '@atlassian/jira-dashboard-view/entrypoint.tsx';
import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { nav4SidebarContentCoreEntryPoint } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-content-core/entrypoint.tsx';
import { nav4DashboardsContentEntryPoint } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-content-dashboards/src/ui/dashboards/default/async-content/entrypoint.tsx';
import { dashboardResources } from './ui/index.tsx';

export const dashboardViewRouteEntry = createEntry(dashboardViewRoute, () => ({
	group: 'dashboard',
	entryPoint: () => pageEntryPoint,
	layout: composeLayouts(globalLayout, dashboardBackgroundScriptsLayout),

	navigation: {
		menuId: MENU_ID.DASHBOARDS,
		sidebarId: SIDEBAR_ID.CONTENT, // Nav4
	},

	resources: [...getNavigationResources(), ...dashboardResources()],

	meta: {
		capability: DASHBOARD,
	},

	earlyAssets: NORMAL_EARLY_ASSET_STRATEGY,
	ufoName: 'dashboard',
	supportsPreviewPanel: true,

	bifrost: {
		bifrostGroup: 'shell-only',

		bundling: {
			packageName:
				'@atlassian/jira-router-routes-dashboard-entries/src/dashboardViewRouteEntry.tsx',
			whichExportToUse: 'dashboardViewRouteEntry',
		},

		enabled: true,
	},
}));

const pageEntryPoint = createPageEntryPoint({
	main: dashboardViewEntryPoint,
	topNavigationMenuId: MENU_ID.DASHBOARDS,
	leftSidebar: {
		sidebar: nav4SidebarContentCoreEntryPoint,
		entryPoints: { dashboards: { entryPoint: nav4DashboardsContentEntryPoint } },
	},
});
